// extracted by mini-css-extract-plugin
export default {"root":"Navigation-module_root__AhX0k","navLink":"Navigation-module_navLink__UdafA","active":"Navigation-module_active___cTsg"};